
export const getInitials = name => {
  if (name) {
    return name
      .replace(/\s+/, " ")
      .split(" ")
      .slice(0, 2)
      .map(v => v && v[0].toUpperCase())
      .join("");
  }
  return "";
};

export const colorFromText = (text, colors) => {
  return colors[numberFromText(text) % colors.length];
};

const numberFromText = (text) => {
  const charCodes = text
    .split('') // => ["A", "A"] 
    .map(char => char.charCodeAt(0)) // => [65, 65]
    .join(''); // => "6565"
  return parseInt(charCodes, 10);
};

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const openInNewCleanWindow = (url) => {
  let win = window.open(url, "_blank");
  win.sessionStorage.clear();
};

export const safeParseJSONString = (content) => {
  try {
    return JSON.parse(content);
  } catch (error) {
    return content;
  }
};